var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeMain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1350 900",
    style: {
      enableBackground: "new 0 0 1350 900"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M487.895,359.415c0.011,0.012,0.023,0.025,0.034,0.037c-0.007-0.016-0.014-0.034-0.021-0.049 C487.745,359.236,487.741,359.24,487.895,359.415z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFDCF"
    },
    d: "M1166.36,834.502c178.56-285.467,106.264-643.274-29.894-659.971 c-60.954-7.475-113.3,1.996-171.137-36.29c-55.745-36.9-110.427-58.943-174.754-50.954 c-128.6,15.974-205.671,140.292-311.249,213.21c-62.344,43.058-119.853,46.641-189.557,46.641 c-55.827,0-114.476,1.51-157.751,51.345c-98.242,113.134-46.626,315.38,21.929,436.018H1166.36z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 706.186,
    y: 93.687,
    style: {
      fill: "#C5FFFD"
    },
    width: 493.594,
    height: 536.332
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M959.422,163.586c0.728-7.517-5.837-11.293-14.413-4.415 c8.97-10.934-11.882-20.359-19.549-8.991c5.507-13.82-18.796-30.345-25.122-1.596c-3.213-5.221-8.097-12.781-15.598-12.609 c-7.734,0.178-8.787,8.025-12.675,14.095c-8.309-11.664-22.193-18.16-31.096-3.143c-4.243-13.625-19.428-24.385-22.337-3.664 c-5.073-10.723-10.803-29.757-27.404-23.477c-13.138,4.97-12.482,22.929-12.338,34.665 c-6.685-6.885-21.471-11.901-29.609-4.254c-3.85,3.618-4.156,9.044-2.29,13.389H959.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1109.053,361.311c0.728-7.517-5.837-11.293-14.413-4.415 c8.97-10.935-11.882-20.359-19.549-8.991c5.507-13.82-18.796-30.344-25.122-1.596c-3.213-5.22-8.097-12.78-15.598-12.609 c-7.734,0.178-8.787,8.025-12.675,14.095c-8.309-11.664-22.193-18.16-31.096-3.143c-4.243-13.625-19.428-24.385-22.337-3.664 c-5.073-10.723-10.803-29.757-27.404-23.477c-13.138,4.97-12.483,22.929-12.338,34.665 c-6.685-6.885-21.471-11.901-29.609-4.254c-3.85,3.618-4.156,9.044-2.29,13.389H1109.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1171.859,205.765c0.536-5.543-4.304-8.327-10.627-3.255 c6.613-8.062-8.761-15.011-14.414-6.629c4.061-10.19-13.858-22.373-18.523-1.177c-2.369-3.849-5.969-9.423-11.5-9.297 c-5.702,0.131-6.478,5.917-9.345,10.393c-6.126-8.6-16.363-13.389-22.928-2.317c-3.128-10.046-14.324-17.98-16.469-2.701 c-3.74-7.906-7.965-21.94-20.205-17.309c-9.687,3.664-9.204,16.906-9.097,25.559c-4.928-5.076-15.831-8.775-21.83-3.137 c-2.839,2.668-3.064,6.668-1.689,9.872H1171.859z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5C8E8A"
    },
    d: "M1079.056,456.946c-30.92-7.693-61.144-4.844-94.197-8.016 c-15.209-1.46-26.187-9.928-39.98-12.129c-15.773-2.517-31.118,6.853-45.761,5.663c-30.075-2.443-50.592-27.04-82.507-19.532 c-21.113,4.967-42.793,10.845-64.18,15.919c-13.228,3.138-30.648,11.727-44.609,12.548v7.846l12.485,13.734 c21.889-6.777,56.493,0,80.663,0c50.066,0,99.7,1.996,149.81,0.007c44.572-1.769,87.977,5.152,132.276,2.443 c25.184-1.54,56.148,1.854,80.022-2.903C1145.089,460.59,1101.675,462.574,1079.056,456.946z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 707.823,
    y: 466.009,
    style: {
      fill: "#58D3D0"
    },
    width: 491.957,
    height: 162.908
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M934.68,458.788c3.068-1.674,8.317-8.835,11.496-9.697 c-1.841,4.089-4.243,9.994-5.459,14.267c18.706,1.405,44.362,7.635,62.987,10.888c-2.701-5.064-22.751-30.56-23.612-35.433 c-2.32-0.297-11.872,3.241-14.198,3.837c-6.165,2.045,10.696-5.499,12.522-6.426c-1.706-1.481-12.151-12.294-25.568-18.741 c-1.018,0.563-2.006,1.149-2.947,1.779c-4.649,3.108-8.937,7.226-13.755,9.72c4.553-3.92,8.894-8.46,13.157-13.065 c-5.694-2.291-11.805-3.648-17.932-3.129c-7.168,0.61-26.443,11.6-30.782,29.092 C898.844,448.905,929.226,454.583,934.68,458.788z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M879.706,413.147c0.864-3.386,6.511-10.24,6.561-13.533 c-3.508,2.792-8.638,6.578-12.478,8.81c-5.975-17.781-16.199-38.039-23.945-55.287c5.575,1.37,33.085,11.443,38.018,11.076 c0.861,2.174-0.212,12.303-0.217,14.705c-0.46,6.479,2.691-11.722,3.139-13.72c1.856,1.288,14.912,8.744,24.468,20.156 c-0.295,1.124-0.621,2.227-0.997,3.294c-1.865,5.272-4.8,10.444-6.027,15.728c2.677-5.379,6.005-10.706,9.417-15.972 c3.625,4.953,6.449,10.539,7.455,16.606c1.178,7.097-4.72,28.487-20.601,37.005 C898.121,445.438,885.125,417.396,879.706,413.147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M882.156,408.903c7.749-1.772,15.166-2.394,22.961-1.877 c5.741,0.381,11.308,2.579,17.021,2.834l0.433,6.138c2.294,9.981-0.122,21.631-0.857,32.063 c-3.707,0.071-11.496,0.231-11.496,0.231s-0.114-11.345-2.05-15.029c-0.196,4.454-1.135,11.335-0.109,15.203 c-10.816,0.729-24.835-1.816-36.109-2.252c0.469-3.423,1.329-7.057,1.979-10.567c-4.404,2.217-10.252,11.491-10.252,11.491 s-6.843,0.093-10.384-0.082c2.449-4.641,6.956-10.033,10.698-14.116c-5.577,2.915-11.354,9.034-17.597,10.249 c-4.759,0.925-11.298-2.376-16.205-2.778C844.099,425.841,862.333,413.435,882.156,408.903z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8215"
    },
    d: "M880.413,389.299c7.867,1.134,15.012,3.222,22.099,6.508 c5.22,2.422,9.623,6.475,14.861,8.769l-1.804,5.882c-1.45,10.137-7.896,20.139-12.333,29.609 c-3.485-1.269-10.809-3.921-10.809-3.921s3.975-10.628,3.494-14.761c-1.786,4.085-5.138,10.169-5.571,14.146 c-10.356-3.211-22.519-10.629-32.882-15.091c1.669-3.025,3.78-6.107,5.648-9.15c-4.906,0.486-13.7,7.035-13.7,7.035 s-6.418-2.376-9.659-3.812c3.954-3.449,10.099-6.859,15.059-9.324c-6.252,0.714-13.843,4.345-20.105,3.233 c-4.773-0.848-9.686-6.281-14.12-8.421C838.81,391.411,860.286,386.395,880.413,389.299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8215"
    },
    d: "M958.645,456.839c-3.049-7.342-6.843-13.745-11.785-19.796 c-3.64-4.457-8.659-7.717-12.179-12.222l-5.251,3.204c-9.462,3.919-17.552,12.643-25.626,19.291 c2.093,3.062,6.479,9.501,6.479,9.501s9.31-6.487,13.433-7.046c-3.515,2.743-8.576,7.499-12.323,8.904 c5.679,9.237,15.881,19.181,22.773,28.114c2.518-2.367,4.979-5.176,7.463-7.741c0.746,4.873-3.417,15.017-3.417,15.017 s3.893,5.628,6.088,8.411c2.36-4.686,4.141-11.484,5.298-16.9c0.859,6.235-0.777,14.489,1.854,20.28 c2.005,4.414,8.487,7.825,11.659,11.59C966.914,497.665,966.447,475.616,958.645,456.839z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#914142"
    },
    d: "M912.843,427.597c0,0-0.073,0.02-0.227,0.067c-0.04,0.007-0.087,0.02-0.134,0.034 c-0.02,0.006-0.054,0.02-0.067,0.02c-0.007,0.007-0.014,0.013-0.02,0.013c-0.014,0.013-0.027,0.02-0.04,0.027 l-0.026,0.007c-0.007,0.007-0.007,0.007-0.033,0.02c-0.341,0.14-0.969,0.454-1.844,1.022 c-0.441,0.287-0.942,0.628-1.49,1.036c-0.3,0.221-0.608,0.454-0.935,0.708c-0.281,0.214-0.575,0.448-0.875,0.688 c-1.075,0.862-2.277,1.89-3.607,3.066c-0.28,0.247-0.574,0.501-0.868,0.768c-0.842,0.755-1.723,1.557-2.658,2.391 c-0.368,0.334-0.742,0.674-1.129,1.022c-0.214,0.194-0.434,0.387-0.655,0.581c-0.394,0.361-0.795,0.714-1.216,1.082 c-0.067,0.06-0.141,0.12-0.207,0.18c-1.009,0.882-2.05,1.797-3.133,2.746c-1.082,0.942-2.198,1.924-3.353,2.932 c-0.581,0.528-1.162,1.062-1.757,1.61c-0.601,0.541-1.203,1.089-1.817,1.65c-0.227,0.207-0.454,0.414-0.688,0.628 c-0.388,0.354-0.781,0.715-1.182,1.075c-0.314,0.287-0.628,0.581-0.948,0.882c-0.314,0.301-0.635,0.601-0.956,0.902 c-1.282,1.216-2.592,2.458-3.941,3.728c-1.336,1.289-2.685,2.619-4.075,3.975c-5.217,5.13-10.755,10.755-16.473,16.84 c-0.341,0.361-0.681,0.721-1.022,1.089c-0.254,0.267-0.508,0.541-0.768,0.815c-0.127,0.127-0.254,0.267-0.381,0.401 c-0.374,0.408-0.761,0.822-1.142,1.236c-0.768,0.828-1.536,1.657-2.311,2.498c-0.768,0.828-1.536,1.663-2.311,2.505 c-0.782,0.862-1.563,1.73-2.351,2.605c-0.788,0.868-1.583,1.75-2.378,2.632c-0.775,0.875-1.55,1.764-2.325,2.652 c-0.775,0.882-1.557,1.777-2.344,2.672c-0.388,0.448-0.775,0.901-1.169,1.363c-0.388,0.461-0.775,0.915-1.169,1.376 c-6.266,7.355-12.538,15.137-18.697,23.2c-4.723,6.179-9.372,12.525-13.928,18.971c-0.742,1.049-1.483,2.104-2.218,3.16 c-0.648,0.922-1.296,1.85-1.937,2.785c-11.737,16.974-22.712,34.482-32.545,51.188 c-4.789,8.15-9.332,16.105-13.547,23.707c-0.107,0.187-0.214,0.374-0.314,0.561c-0.648,1.175-1.296,2.344-1.93,3.494 c-0.347,0.635-0.688,1.263-1.036,1.884c-2.572,4.696-5.016,9.232-7.334,13.574h-23.68 c1.316-2.251,2.686-4.576,4.108-6.967c2.378-4.001,4.89-8.196,7.521-12.545c1.823-3.006,3.708-6.086,5.651-9.232 c4.75-7.682,9.853-15.731,15.25-23.987c5.404-8.257,11.109-16.707,17.067-25.197c5.951-8.484,12.164-17.001,18.557-25.377 c6.399-8.376,12.986-16.613,19.673-24.555c6.68-7.943,13.466-15.591,20.233-22.806c0.421-0.448,0.841-0.902,1.262-1.349 c0.421-0.454,0.842-0.902,1.269-1.342c0.855-0.888,1.71-1.777,2.552-2.652c0.848-0.882,1.69-1.757,2.532-2.625 c0.835-0.842,1.67-1.683,2.498-2.518c0.828-0.835,1.657-1.664,2.472-2.485l0.655-0.655c0.207-0.2,0.414-0.407,0.628-0.608 c0.415-0.407,0.829-0.815,1.236-1.222c0.828-0.808,1.643-1.617,2.465-2.418c0.407-0.401,0.808-0.795,1.216-1.196 c0.408-0.394,0.822-0.789,1.223-1.176c6.373-6.199,12.551-11.931,18.363-17.127c0.087-0.08,0.181-0.16,0.267-0.241 c1.476-1.309,2.912-2.598,4.335-3.841c1.222-1.042,2.412-2.071,3.581-3.073c0.207-0.18,0.414-0.354,0.621-0.535 c0.341-0.294,0.681-0.588,1.015-0.875c0.341-0.287,0.668-0.574,1.015-0.855c0.681-0.568,1.349-1.116,2.011-1.67 c1.316-1.089,2.598-2.151,3.841-3.18c1.757-1.403,3.44-2.732,5.03-4.001c0.221-0.174,0.441-0.347,0.655-0.521 c0.441-0.347,0.869-0.688,1.296-1.028c0.495-0.394,0.982-0.788,1.463-1.176c0.194-0.16,0.387-0.314,0.575-0.474 c0.067-0.054,0.134-0.107,0.194-0.154c0.26-0.22,0.521-0.427,0.775-0.641c0.982-0.802,1.924-1.57,2.812-2.298 c3.601-2.926,6.627-5.171,9.044-6.566c1.216-0.701,2.285-1.203,3.126-1.503c0.047-0.014,0.12-0.04,0.18-0.06 c0.06-0.02,0.12-0.04,0.181-0.06c0.113-0.033,0.227-0.067,0.327-0.1c0.047-0.013,0.094-0.027,0.14-0.04 c0.033-0.007,0.06-0.014,0.087-0.02c0.047-0.014,0.093-0.02,0.127-0.034c0.154-0.033,0.24-0.054,0.24-0.054l0.635,2.432 l0.167,0.641L912.843,427.597z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#773236"
    },
    d: "M790.753,556.992c0.015,0.012,0.03,0.022,0.044,0.034 C790.784,557.016,790.769,557.005,790.753,556.992z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#773236"
    },
    d: "M864.795,457.189c-3.687,4.449-8.116,8.277-11.69,13.052 c1.757,1.991,3.62,4.509,5.384,7.054c-0.341,0.361-0.681,0.721-1.022,1.089c-0.254,0.267-0.508,0.541-0.768,0.815 c-2.037-1.991-4.042-3.981-6.125-5.898c-7.702,9.606-17.515,17.401-25.584,26.9c1.683,1.951,3.42,3.567,4.696,5.698 c-1.997-1.703-4.021-3.427-6.106-4.983c-9.158,9.973-16.713,21.075-24.682,31.743c2.451,2.832,4.883,5.751,7.294,8.651 c-0.742,1.049-1.483,2.104-2.218,3.16c-2.478-1.43-4.903-2.899-7.201-4.309c-2.973,4.362-6.6,9.025-8.891,13.687 c0.822,0.708,2.411,2.759,2.872,3.146c-1.69-1.383-3.226-1.343-4.95-1.67c0.755,0.902,1.102,2.378,1.784,3.306 c-6.159-1.008-11.757,14.068-14.749,18.931c-4.516,7.314-13.066,15.117-9.318,23.213 c-5.043-1.837-8.163-3.053-12.064,0.04c-1.636,1.303-8.677,10.307-8.617,12.358c0.073,2.606,2.813,5.792,6.239,8.978 c1.47,1.369,3.06,2.732,4.623,4.055c-0.347,0.635-0.688,1.263-1.036,1.884c-4.355-2.345-8.978-4.389-13.213-5.938 c-0.595-0.22-1.182-0.428-1.764-0.628c-0.12,0.214-0.24,0.421-0.354,0.628c-4.055,7.254-5.972,13.787-6.62,19.512h-9.065 c1.316-2.251,2.686-4.576,4.108-6.967c2.378-4.001,4.89-8.196,7.521-12.545c1.823-3.006,3.708-6.086,5.651-9.232 c4.75-7.682,9.853-15.731,15.25-23.987c5.404-8.257,11.109-16.707,17.067-25.197 c5.951-8.484,12.164-17.001,18.557-25.377c6.399-8.376,12.986-16.613,19.673-24.555 c6.68-7.943,13.466-15.591,20.233-22.806c0.421-0.448,0.841-0.902,1.262-1.349c0.421-0.454,0.842-0.902,1.269-1.342 c0.855-0.888,1.71-1.777,2.552-2.652c0.848-0.882,1.69-1.757,2.532-2.625c0.835-0.842,1.67-1.683,2.498-2.518 c0.828-0.835,1.657-1.664,2.472-2.485l0.655-0.655c0.207-0.2,0.414-0.407,0.628-0.608 c0.415-0.407,0.829-0.815,1.236-1.222c0.828-0.808,1.643-1.617,2.465-2.418c0.407-0.401,0.808-0.795,1.216-1.196 c0.408-0.394,0.822-0.789,1.223-1.176c6.373-6.199,12.551-11.931,18.363-17.127c0.167,3.534,0.227,7.127,1.122,10.501 C867.974,461.738,866.244,459.467,864.795,457.189z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M904.253,407.254c-4.627,8.578-8.897,23.939-11.951,27.558 c1.535,3.141,8.459,8.701,9.179,11.914c-4.003-2.02-9.797-4.681-14.012-6.085c-2.231,18.626-9.589,43.981-13.661,62.444 c5.178-2.475,31.535-21.377,36.441-22.023c0.4-2.303-2.713-12.002-3.206-14.353c-1.77-6.251,5.022,10.929,5.865,12.794 c1.556-1.639,12.821-11.596,19.853-24.714c-0.517-1.042-1.059-2.055-1.646-3.023c-2.899-4.783-6.824-9.248-9.102-14.172 c3.715,4.722,8.059,9.259,12.471,13.721c1.077-2.37,1.99-4.819,2.666-7.324c0.918-3.405,1.395-6.911,1.253-10.452 c-0.292-7.187-10.421-26.93-27.703-32.037C908.531,400.861,906.356,403.356,904.253,407.254z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M898.705,272.286c3.183-3.379,7.007-14.736,10.633-17.105 c-0.748,6.028-1.507,14.637-1.409,20.658c23.776-5.538,58.005-7.55,82.377-10.66c-5.268-5.507-39.79-30.697-42.697-36.679 c-2.995,0.527-13.532,8.876-16.197,10.566c-6.893,5.078,11.219-11.344,13.137-13.266 c-2.679-1.25-19.734-11.169-38.835-14.253c-1.053,1.132-2.059,2.281-2.992,3.467c-4.608,5.861-8.383,12.892-13.431,18.023 c4.182-6.878,7.864-14.475,11.425-22.129c-7.94-0.732-16.043-0.089-23.462,2.997c-8.677,3.612-28.486,25.456-27.285,49.858 C850.45,273.565,890.344,268.977,898.705,272.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M813.188,234.703c-0.203-4.732,4.231-15.847,3.054-20.139 c-3.307,5.004-8.256,11.935-12.186,16.342c-14.129-20.72-34.467-42.979-50.594-62.309 c7.444-0.416,45.426,1.827,51.418-0.591c1.889,2.481,4.374,16.046,5.273,19.165c1.871,8.587-1.073-16.268-1.27-19.035 c2.792,0.939,21.827,5.476,38.003,16.521c0.057,1.576,0.069,3.133,0.003,4.666c-0.328,7.574-2.026,15.439-1.562,22.777 c1.299-8.032,3.427-16.254,5.682-24.429c6.371,5,11.985,11.136,15.523,18.611c4.138,8.743,4.872,38.816-11.652,56.118 C848.243,269.352,821.524,238.083,813.188,234.703z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M814.635,228.234c8.961-5.349,17.944-9.075,27.826-11.471 c7.278-1.765,15.023-1.103,22.219-3.02l2.852,7.792c6.611,12.047,8.001,28.113,11.02,41.936 c-4.58,1.55-14.199,4.824-14.199,4.824s-4.418-14.676-8.212-18.693c1.434,5.855,2.861,15.154,5.594,19.766 c-13.168,5.203-31.547,7.417-45.72,11.289c-0.708-4.625-1.01-9.68-1.525-14.49c-4.637,4.61-8.41,18.944-8.41,18.944 s-8.467,2.812-12.933,3.979c1.294-6.985,4.863-15.754,7.972-22.524c-5.832,5.977-10.705,16.19-18.006,20.222 c-5.564,3.072-14.935,1.362-21.182,2.772C773.726,265.184,791.71,241.913,814.635,228.234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8215"
    },
    d: "M805.078,203.483c10.204-1.624,19.869-1.727,29.915-0.252 c7.4,1.088,14.398,4.615,21.772,5.529l-0.024,8.34c2.018,13.724-2.222,29.237-4.167,43.268 c-4.808-0.275-14.91-0.833-14.91-0.833s0.934-15.353-1.222-20.524c-0.68,6.001-2.552,15.213-1.59,20.545 c-14.08-0.092-31.99-4.93-46.549-6.641c0.933-4.581,2.393-9.41,3.57-14.093c-5.914,2.562-14.373,14.518-14.373,14.518 s-8.872-0.556-13.44-1.144c3.614-6.031,9.964-12.874,15.198-18.022c-7.5,3.387-15.564,11.085-23.766,12.106 c-6.251,0.777-14.404-4.339-20.72-5.37C754.176,222.596,778.975,207.637,805.078,203.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7F8215"
    },
    d: "M927.75,260.325c-6.555-8.323-13.683-15.139-22.104-21.045 c-6.204-4.35-13.668-6.605-19.742-11.065l-5.318,6.224c-10.28,8.809-17.045,23.311-24.572,35.112 c3.755,3.148,11.631,9.776,11.631,9.776s9.125-12.078,14.036-14.427c-3.333,4.942-7.83,13.105-11.956,16.402 c10.538,9.75,26.964,18.637,38.894,27.514c2.239-4.061,4.238-8.675,6.358-12.98c2.765,6.03,1.412,20.828,1.412,20.828 s6.957,5.769,10.735,8.517c1.169-7.008,0.819-16.529,0.214-24.011c3.417,7.75,4.496,19.103,9.948,25.581 c4.157,4.937,13.495,6.813,18.857,10.45C953.415,310.041,944.525,281.618,927.75,260.325z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#914142"
    },
    d: "M857.079,235.749l-0.455-0.768l-1.71-2.899c0,0-0.094,0.054-0.274,0.167 c-0.04,0.026-0.094,0.053-0.147,0.087c-0.033,0.02-0.066,0.04-0.1,0.06c-0.047,0.04-0.107,0.074-0.16,0.114 c-0.114,0.08-0.234,0.167-0.368,0.26c-0.067,0.047-0.133,0.094-0.2,0.147c-0.067,0.047-0.154,0.107-0.2,0.147 c-0.935,0.721-2.071,1.79-3.32,3.18c-2.478,2.765-5.391,6.86-8.764,12.077c-0.828,1.296-1.71,2.659-2.625,4.088 c-0.24,0.374-0.481,0.755-0.721,1.136c-0.061,0.093-0.12,0.187-0.18,0.281c-0.174,0.274-0.354,0.554-0.535,0.835 c-0.454,0.701-0.915,1.403-1.383,2.111c-0.401,0.608-0.808,1.222-1.222,1.85c-0.2,0.3-0.401,0.608-0.614,0.922 c-1.497,2.271-3.08,4.663-4.743,7.167c-1.156,1.824-2.352,3.707-3.58,5.644c-0.608,0.969-1.236,1.951-1.871,2.953 c-0.32,0.494-0.621,1.002-0.928,1.51c-0.314,0.508-0.621,1.022-0.935,1.53c-0.187,0.307-0.381,0.621-0.575,0.935 c-1.069,1.764-2.171,3.567-3.286,5.404c-1.296,2.171-2.599,4.409-3.941,6.687c-0.08,0.14-0.161,0.281-0.24,0.421 c-5.264,9.025-10.781,18.891-16.366,29.439c-0.354,0.668-0.715,1.343-1.076,2.01c-0.354,0.675-0.708,1.356-1.062,2.031 c-0.715,1.363-1.43,2.732-2.144,4.108c-0.361,0.688-0.721,1.376-1.089,2.071l-0.541,1.042l-0.274,0.521l-0.294,0.575 c-0.708,1.396-1.416,2.799-2.131,4.202c-0.721,1.416-1.436,2.832-2.158,4.255c-0.721,1.456-1.429,2.919-2.158,4.396 c-0.721,1.476-1.443,2.959-2.171,4.449c-0.368,0.742-0.722,1.49-1.076,2.238c-0.347,0.748-0.702,1.503-1.056,2.251 c-5.691,12.024-11.242,24.616-16.553,37.548c-5.317,12.939-10.394,26.219-15.183,39.605 c-4.796,13.387-9.299,26.873-13.5,40.227c-4.208,13.353-8.109,26.566-11.71,39.405 c-2.057,7.334-4.021,14.542-5.878,21.583c-1.403,5.284-2.745,10.468-4.035,15.544 c-3.006,11.837-5.718,23.059-8.163,33.427c-1.797,7.636-3.428,14.799-4.916,21.424v23.857l22.337,9.795 c0.467-2.759,0.969-5.765,1.516-9.004c0.361-2.118,0.742-4.328,1.136-6.64c0.287-1.677,0.588-3.4,0.888-5.17 c0.047-0.254,0.087-0.501,0.134-0.748c1.449-8.237,3.093-17.481,4.976-27.515c1.49-7.922,3.113-16.339,4.883-25.15 c0.187-0.948,0.381-1.897,0.568-2.852c0.361-1.75,0.721-3.513,1.082-5.29c2.425-11.79,5.124-24.175,8.083-36.947 c5.918-25.537,12.952-52.577,21.142-79.217c0.448-1.463,0.902-2.926,1.356-4.382c0.521-1.657,1.042-3.313,1.57-4.964 c3.233-10.16,6.62-20.22,10.16-30.093c4.609-12.892,9.465-25.45,14.489-37.461c0.314-0.748,0.622-1.496,0.935-2.244 c0.307-0.748,0.621-1.496,0.935-2.231c0.641-1.469,1.276-2.932,1.904-4.389c0.635-1.463,1.263-2.912,1.89-4.355 c0.655-1.456,1.31-2.912,1.958-4.356c0.655-1.443,1.303-2.879,1.944-4.302c0.648-1.396,1.289-2.779,1.931-4.155 c0.648-1.396,1.289-2.778,1.931-4.155c0.32-0.688,0.641-1.369,0.955-2.057c0.113-0.221,0.214-0.448,0.327-0.668 c0.214-0.454,0.434-0.909,0.648-1.363c0.287-0.601,0.568-1.202,0.855-1.804c4.81-10.147,9.572-19.626,14.121-28.336 c1.216-2.298,2.392-4.562,3.567-6.753c1.196-2.184,2.358-4.309,3.494-6.386c0.287-0.521,0.568-1.042,0.849-1.55 c0.28-0.514,0.561-1.022,0.848-1.516c0.361-0.628,0.715-1.256,1.062-1.87c0.207-0.361,0.408-0.721,0.615-1.075 c0.547-0.962,1.089-1.91,1.623-2.846c0.541-0.949,1.069-1.877,1.59-2.792c1.055-1.764,2.078-3.474,3.059-5.13 c0.996-1.656,1.944-3.253,2.866-4.79c0.06-0.106,0.127-0.207,0.187-0.314c0.381-0.641,0.748-1.27,1.109-1.877 c0.193-0.341,0.394-0.681,0.588-1.015c0.347-0.601,0.688-1.189,1.022-1.77c0.841-1.456,1.637-2.839,2.398-4.148 c0.267-0.454,0.528-0.902,0.788-1.336c1.202-2.044,2.311-3.848,3.327-5.404c0.28-0.434,0.561-0.842,0.828-1.236 c0.307-0.454,0.608-0.888,0.895-1.289c0.534-0.742,1.022-1.383,1.456-1.93c0.882-1.075,1.543-1.73,1.911-2.051 c0.033-0.027,0.027-0.02,0.04-0.033l0.027-0.027c0.014-0.014,0.026-0.027,0.04-0.04c0.007-0.013,0.013-0.02,0.021-0.026 c0.013-0.014,0.053-0.04,0.073-0.054c0.053-0.04,0.107-0.074,0.147-0.1c0.174-0.12,0.267-0.18,0.267-0.18L857.079,235.749 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#773236"
    },
    d: "M756.865,456.334c0.024,0.01,0.046,0.017,0.067,0.027 C756.913,456.353,756.891,456.344,756.865,456.334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#773236"
    },
    d: "M814,291.794c-5.264,9.025-10.781,18.891-16.366,29.439 c-0.354,0.668-0.715,1.343-1.076,2.01c-0.354,0.675-0.708,1.356-1.062,2.031c-0.715,1.363-1.43,2.732-2.144,4.108 c-0.361,0.688-0.721,1.376-1.089,2.071l-0.541,1.042l-0.274,0.521l-0.294,0.575c-0.708,1.396-1.416,2.799-2.131,4.202 c-0.721,1.416-1.436,2.832-2.158,4.255c-0.721,1.456-1.429,2.919-2.158,4.396c-0.721,1.476-1.443,2.959-2.171,4.449 c-0.368,0.742-0.722,1.49-1.076,2.238c-0.347,0.748-0.702,1.503-1.056,2.251c-5.691,12.024-11.242,24.616-16.553,37.548 c-5.317,12.939-10.394,26.219-15.183,39.605c-4.796,13.387-9.299,26.873-13.5,40.227 c-4.208,13.353-8.109,26.566-11.71,39.405c-2.057,7.334-4.021,14.542-5.878,21.583 c-1.403,5.284-2.745,10.468-4.035,15.544c-3.006,11.837-5.718,23.059-8.163,33.427 c-1.797,7.636-3.428,14.799-4.916,21.424v23.857l22.337,9.795c0.467-2.759,0.969-5.765,1.516-9.004 c0.361-2.118,0.742-4.328,1.136-6.64c0.287-1.677,0.588-3.4,0.888-5.17c0.047-0.254,0.087-0.501,0.134-0.748 c-2.826-3.433-6.239-8.223-8.898-14.643c-3.974-9.586-6.252-22.819-2.338-40.647c0.768,0.027,1.543,0.067,2.338,0.114 c5.872,0.347,12.425,1.182,18.757,2.511c0.187-0.948,0.381-1.897,0.568-2.852c-8.136-3.661-16.88-7.849-18.41-12.638 c-0.841-2.639,4.509-17.087,6.058-19.425c3.674-5.551,8.003-5.197,14.97-4.796c-7.709-9.031-0.02-22.518,2.825-33.787 c1.891-7.482,3.167-29.251,11.203-30.367c-1.196-0.935-2.191-2.712-3.467-3.587c2.265-0.254,4.161-0.909,6.78,0.22 c-0.721-0.321-3.467-2.358-4.749-2.946c1.082-6.954,3.834-14.429,5.885-21.262c3.387,0.922,6.953,1.877,10.567,2.752 c0.521-1.657,1.042-3.313,1.57-4.964c-4.088-2.819-8.21-5.644-12.325-8.357c5.878-16.974,11.082-34.355,18.704-50.901 c3.173,1.202,6.346,2.639,9.472,4.068c-2.391-2.264-5.163-3.674-7.982-5.544c6.439-15.497,15.698-29.472,21.649-44.969 c3.313,1.67,6.553,3.46,9.84,5.237c0.214-0.454,0.434-0.909,0.648-1.363c0.287-0.601,0.568-1.202,0.855-1.804 c-3.153-2.612-6.413-5.144-9.345-7.04c2.638-7.595,6.7-14.309,9.606-21.536c2.659,2.392,5.658,4.656,8.089,7.261 C816.966,300.945,815.536,296.31,814,291.794z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M841.471,217.398c-2.517,12.95-2.034,34.56-4.464,40.457 c3.092,3.469,13.792,7.96,15.898,11.845c-5.737-1.046-13.941-2.218-19.706-2.382c4.248,25.044,4.659,60.835,6.558,86.393 c5.504-5.249,31.132-40.146,36.986-42.914c-0.372-3.146-7.894-14.504-9.394-17.361 c-4.555-7.412,10.358,12.203,12.111,14.29c1.316-2.738,11.561-20.089,15.355-39.877c-1.034-1.148-2.092-2.249-3.185-3.273 c-5.405-5.064-11.966-9.312-16.653-14.805c6.397,4.664,13.506,8.843,20.669,12.895c0.447-3.498,0.655-7.035,0.551-10.551 c-0.141-4.779-0.87-9.515-2.381-14.053c-3.072-9.211-23.101-30.838-46.5-30.664 C844.378,207.42,842.616,211.514,841.471,217.398z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M819.75,625.636l-6.252-11.481l8.445,11.481h27.829c4.977-2.498,9.56-5.264,13.496-8.283 c-1.199-4.195-1.657-14.231-2.826-18.231c3.766,3.237,6.917,8.619,10.036,13.635c10.03-12.225,24.209-17.164,32.832-31.691 c-8.106-1.986-36.977-7.576-56.69-3.509c0.33,7.451,1.689,15.447,1.87,20.927c-3.337-4.707-6.335-12.679-8.504-19.028 c-8.524,3.273-13.876,9.344-12.352,19.856c-0.449-1.606-5.629-12.682-6.301-14.924 c-26.247,15.667-39.057,31.128-45.17,41.248H819.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M749.396,625.636c4.606-7.424,9.179-16.551,12.964-26.216l-23.628-3.707l24.848,0.498 c4.745-12.866,7.979-26.438,7.979-38.044c-4.058-1.601-12.301-7.346-16.185-8.852c4.86-1.018,11.048-0.244,16.927,0.333 c-3.597-15.398,1.114-29.655-5.165-45.338c-6.509,5.224-28.515,24.73-37.285,42.847c6.113,4.272,13.284,8.061,17.744,11.251 c-5.766-0.216-13.916-2.689-20.274-4.832c-2.59,8.755-1.03,16.698,8.239,21.886c-1.548-0.621-13.489-3.251-15.677-4.083 c-2.913,24.969-0.405,42.642,2.974,54.257H749.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M750.426,625.636h40.789c1.324-1.632,2.634-3.299,3.915-5.001l-21.759-9.928l23.799,7.166 c8.03-11.114,14.796-23.316,17.918-34.496c-3.478-2.633-9.871-10.383-13.208-12.879c4.955,0.326,10.706,2.736,16.214,4.874 c0.679-15.798,9.05-28.262,7.223-45.056c-7.674,3.28-34.117,16.147-47.439,31.237c4.738,5.758,10.627,11.336,14.064,15.609 c-5.495-1.76-12.68-6.334-18.228-10.108c-4.849,7.735-5.484,15.805,2.048,23.295c-1.323-1.015-12.116-6.76-14.001-8.149 C754.513,599.912,751.429,614.393,750.426,625.636z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#90981E"
    },
    d: "M1127.725,628.643h5.785l13.606-18.496l-10.072,18.496h51.063 c-3.748-8.666-15.381-28.298-48.827-48.263c-0.672,2.243-5.852,13.318-6.301,14.924 c1.524-10.512-3.828-16.583-12.352-19.857c-2.169,6.35-5.167,14.322-8.504,19.028c0.182-5.48,1.541-13.476,1.87-20.927 c-19.714-4.066-48.584,1.524-56.69,3.509c8.623,14.526,22.802,19.465,32.832,31.691c3.12-5.016,6.27-10.398,10.036-13.635 c-1.169,4-1.627,14.035-2.826,18.231C1105.456,619.567,1116.305,624.724,1127.725,628.643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C6C64B"
    },
    d: "M1194.536,580.778c-3.837,2.176-8.815,4.896-9.687,5.565 c7.531-7.49,6.896-15.56,2.048-23.295c-5.548,3.774-12.733,8.349-18.228,10.108c3.438-4.273,9.327-9.851,14.064-15.609 c-13.322-15.091-39.765-27.958-47.438-31.237c-1.828,16.794,6.544,29.258,7.222,45.056 c5.508-2.138,11.259-4.548,16.214-4.874c-3.336,2.496-9.729,10.245-13.208,12.879c3.122,11.18,9.888,23.382,17.918,34.496 l23.799-7.166l-21.759,9.928c3.192,4.238,6.546,8.281,9.921,12.015h19.133V580.778z"
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M715.244,560.942c-3.914,17.829-1.636,31.062,2.338,40.647v-40.534 C716.787,561.009,716.012,560.968,715.244,560.942z M699.62,85.451v556.211h262.648V85.451H699.62z M944.312,622.15h-226.73 V104.963h226.73V622.15z M715.244,560.942c-3.914,17.829-1.636,31.062,2.338,40.647v-40.534 C716.787,561.009,716.012,560.968,715.244,560.942z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1208.826,641.664H946.179V85.454h262.647V641.664z M964.136,622.151h226.732V104.966H964.136 V622.151z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 700.732,
    y: 652.689,
    style: {
      fill: "#D1D3D3"
    },
    width: 506.982,
    height: 19.037
  }), /*#__PURE__*/React.createElement("rect", {
    x: 685.703,
    y: 635.656,
    style: {
      fill: "#E8ECED"
    },
    width: 537.039,
    height: 23.044
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 315.601,
    y: 174.163,
    transform: "matrix(0.9633 -0.2686 0.2686 0.9633 -46.9252 98.9566)",
    style: {
      fill: "#468E80"
    },
    width: 45.18,
    height: 93.624
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5AAF9F"
    },
    d: "M338.844,172.194l23.167,83.082c1.093,3.922,5.8,6.036,10.513,4.721 c4.712-1.314,7.647-5.559,6.552-9.48l-23.166-83.083L338.844,172.194z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 346.995,
    y: 183.026,
    transform: "matrix(0.9633 -0.2686 0.2686 0.9633 -37.3832 101.6261)",
    style: {
      fill: "#FFAE43"
    },
    width: 11.517,
    height: 8.846
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 286.204,
    y: 158.967,
    style: {
      fill: "#5C8C37"
    },
    width: 45.18,
    height: 107.63
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8ABC5E"
    },
    d: "M322.57,158.967c-0.029,0.275-0.044,0.553-0.044,0.835v98.451 c0,4.609,3.966,8.344,8.858,8.344c4.893,0,8.86-3.735,8.86-8.344v-98.451c0-0.282-0.016-0.56-0.046-0.835H322.57z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 326.068,
    y: 164.127,
    style: {
      fill: "#FFFFFF"
    },
    width: 9.745,
    height: 22.853
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 244.568,
    y: 185.505,
    style: {
      fill: "#468E80"
    },
    width: 45.18,
    height: 81.829
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#81E2E2"
    },
    d: "M280.891,185.505v75.385c0,3.559,3.966,6.443,8.857,6.443c4.893,0,8.86-2.884,8.86-6.443 v-75.385H280.891z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 284.433,
    y: 197.747,
    style: {
      fill: "#DD4767"
    },
    width: 11.516,
    height: 7.732
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 221.684,
    y: 196.337,
    style: {
      fill: "#295989"
    },
    width: 31.73,
    height: 72.393
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3E7CC6"
    },
    d: "M247.193,196.337v66.692c0,3.148,2.786,5.7,6.221,5.7c3.436,0,6.221-2.551,6.221-5.7v-66.692 H247.193z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 249.68,
    y: 207.168,
    style: {
      fill: "#FFAE43"
    },
    width: 8.089,
    height: 6.84
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.152,
    y: 185.506,
    style: {
      fill: "#1E4968"
    },
    width: 31.731,
    height: 83.223
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#478CBF"
    },
    d: "M226.693,185.506c-0.021,0.213-0.032,0.428-0.032,0.646v76.126 c0,3.564,2.785,6.451,6.222,6.451c3.436,0,6.221-2.888,6.221-6.451v-76.126c0-0.218-0.011-0.433-0.032-0.646H226.693z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 229.15,
    y: 189.496,
    style: {
      fill: "#1E4968"
    },
    width: 6.843,
    height: 6.63
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.15,
    y: 199.689,
    style: {
      fill: "#1E4968"
    },
    width: 6.843,
    height: 7.478
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 171.912,
    y: 206.027,
    style: {
      fill: "#3E7CC6"
    },
    width: 31.73,
    height: 63.272
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#499AEA"
    },
    d: "M197.42,206.027v58.29c0,2.751,2.785,4.982,6.222,4.982c3.436,0,6.221-2.23,6.221-4.982 v-58.29H197.42z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 199.909,
    y: 215.493,
    style: {
      fill: "#FFFFFF"
    },
    width: 8.088,
    height: 5.978
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9C9B5"
    },
    d: "M402.697,268.664c0,5.804-2.382,10.508-5.323,10.508H153.842c-2.939,0-5.321-4.704-5.321-10.508 c0-2.906,0.594-5.526,1.558-7.43c0.964-1.904,2.292-3.078,3.763-3.078h243.531 C400.315,258.155,402.697,262.859,402.697,268.664z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7AEAF"
    },
    d: "M402.697,268.664c0,5.804-2.382,10.508-5.323,10.508H206.431c-2.94,0-5.322-4.704-5.322-10.508 c0-2.906,0.594-5.526,1.559-7.43c0.964-1.904,2.292-3.078,3.763-3.078h190.943 C400.315,258.155,402.697,262.859,402.697,268.664z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A7AEAF"
    },
    d: "M1269.649,831.83c0,14.757-266.233,26.719-594.649,26.719S80.352,846.586,80.352,831.83 c0-14.757,266.233-26.72,594.648-26.72S1269.649,817.073,1269.649,831.83z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818687"
    },
    d: "M1093.505,829.783c0,6.342-211.065,11.482-471.427,11.482 c-260.362,0-471.427-5.14-471.427-11.482c0-6.341,211.065-11.482,471.427-11.482 C882.44,818.3,1093.505,823.442,1093.505,829.783z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D1016"
    },
    d: "M537.354,353.515l-18.982,121.686c-0.912,5.848,2.671,10.584,8.013,10.584l173.515,0.009 c0.391,0,0.776-0.022,1.166-0.08c4.907-0.615,9.453-5.081,10.456-10.503l22.503-121.686 c1.081-5.841-2.466-10.579-7.915-10.579l-177.235-0.009C543.421,342.936,538.266,347.673,537.354,353.515z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43443F"
    },
    d: "M505.793,475.203c-0.9,5.844,2.838,10.58,8.352,10.581l179.229,0.01 c5.513,0,10.855-4.737,11.93-10.58l22.39-121.686c1.076-5.843-2.619-10.58-8.251-10.581l-183.068-0.009 c-5.633-0.001-10.928,4.737-11.828,10.58L505.793,475.203z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8D6D2"
    },
    d: "M512.248,458.172c-0.76,4.921,2.958,8.911,8.304,8.912l173.824,0.009 c5.348,0,10.416-3.99,11.319-8.911l18.816-102.495c0.903-4.921-2.777-8.913-8.221-8.913l-176.952-0.009 c-5.444-0.001-10.474,3.99-11.235,8.911L512.248,458.172z"
  }))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "535.664,352.02 517.819,466.617 698.477,466.626 719.418,352.029  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "651.062,430.86 650.917,431.69 619.402,431.689 619.542,430.858  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "659.228,430.86 670.293,430.861 670.146,431.691 659.083,431.69  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "658.355,435.841 669.411,435.841 669.265,436.671 658.209,436.67  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "650.194,435.84 650.049,436.67 618.557,436.668 618.698,435.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "657.48,440.82 668.528,440.82 668.381,441.651 657.334,441.65  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "649.325,440.819 649.18,441.649 617.711,441.648 617.853,440.818  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "656.605,445.8 667.646,445.8 667.498,446.63 656.459,446.629  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "648.457,445.8 648.312,446.629 616.866,446.628 617.007,445.797  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "655.732,450.779 666.763,450.78 666.616,451.609 655.586,451.609  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "647.589,450.778 647.444,451.608 635.262,451.608 635.406,450.778  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "654.858,455.759 665.882,455.759 665.734,456.59 654.711,456.589  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "646.72,455.759 646.575,456.588 634.403,456.587 634.546,455.758  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "650.661,433.16 650.516,433.99 619.012,433.988 619.152,433.158  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "658.825,433.16 669.886,433.161 669.739,433.991 658.679,433.99  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "657.95,438.14 669.003,438.141 668.857,438.971 657.804,438.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "649.792,438.14 649.648,438.97 618.166,438.968 618.307,438.138  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "657.075,443.119 668.121,443.12 667.974,443.95 656.93,443.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "648.924,443.119 648.779,443.949 617.322,443.947 617.463,443.118  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "656.202,448.099 667.237,448.1 667.091,448.93 656.056,448.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "648.055,448.099 647.912,448.928 616.476,448.926 616.617,448.097  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "655.328,453.078 666.356,453.079 666.209,453.909 655.181,453.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "647.187,453.078 647.042,453.909 634.865,453.908 635.007,453.077  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "654.453,458.059 665.473,458.06 665.326,458.889 654.307,458.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "646.319,458.058 646.174,458.888 634.006,458.887 634.149,458.057  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "536.957,406.099 548.02,406.1 547.88,406.93 536.816,406.929  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "536.122,411.079 547.18,411.079 547.04,411.909 535.983,411.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "535.29,416.058 546.339,416.059 546.198,416.889 535.151,416.888  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "534.457,421.038 545.498,421.039 545.357,421.868 534.319,421.868  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "533.624,426.018 544.657,426.018 544.516,426.848 533.485,426.847  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "532.791,430.997 543.815,430.998 543.675,431.828 532.653,431.827  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "536.57,408.399 547.631,408.4 547.492,409.229 536.432,409.229  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "535.738,413.378 546.791,413.379 546.651,414.21 535.599,414.21  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "534.906,418.357 545.95,418.358 545.81,419.189 534.767,419.188  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "534.073,423.337 545.109,423.338 544.969,424.168 533.933,424.168  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "533.239,428.317 544.268,428.318 544.128,429.148 533.101,429.147  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "532.406,433.297 543.427,433.298 543.286,434.127 532.268,434.127  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "542.396,370.742 553.461,370.743 553.323,371.573 542.259,371.573  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "541.576,375.722 552.632,375.723 552.495,376.552 541.438,376.552  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "540.756,380.701 551.805,380.702 551.666,381.532 540.618,381.531  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "539.935,385.682 550.976,385.682 550.838,386.512 539.797,386.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "539.114,390.661 550.147,390.661 550.009,391.492 538.978,391.491  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "538.294,395.64 549.318,395.641 549.181,396.471 538.157,396.471  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "542.017,373.041 553.078,373.042 552.94,373.872 541.881,373.872  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "541.197,378.022 552.251,378.023 552.112,378.853 541.06,378.852  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "540.376,383.001 551.422,383.002 551.284,383.832 540.24,383.831  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "539.556,387.981 550.593,387.981 550.456,388.811 539.419,388.81  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "538.737,392.961 549.765,392.961 549.627,393.791 538.599,393.79  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "537.916,397.94 548.936,397.94 548.798,398.771 537.778,398.77  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "558.355,371.281 569.421,371.282 569.285,372.112 558.221,372.111  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "557.547,376.261 568.604,376.262 568.468,377.092 557.412,377.091  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "556.74,381.24 567.788,381.24 567.652,382.071 556.605,382.07  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "555.932,386.22 566.973,386.22 566.837,387.05 555.798,387.05  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "555.123,391.199 566.156,391.199 566.02,392.03 554.99,392.03  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "554.316,396.18 565.341,396.18 565.204,397.01 554.18,397.009  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "557.982,373.581 569.043,373.582 568.908,374.412 557.847,374.411  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "557.174,378.561 568.227,378.561 568.092,379.392 557.04,379.391  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "556.367,383.539 567.411,383.54 567.276,384.371 556.232,384.37  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "555.558,388.52 566.595,388.52 566.459,389.35 555.423,389.349  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "554.751,393.499 565.78,393.5 565.643,394.33 554.617,394.329  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "553.943,398.479 564.964,398.479 564.827,399.309 553.809,399.308  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "574.555,371.201 603.328,371.203 603.194,372.032 574.425,372.031  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "573.772,376.182 602.524,376.183 602.39,377.013 573.642,377.011  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "572.99,381.159 601.72,381.161 601.586,381.992 572.86,381.991  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "572.208,386.14 600.917,386.142 600.783,386.971 572.079,386.97  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "571.426,391.119 600.113,391.121 599.979,391.952 571.296,391.95  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "570.643,396.1 599.309,396.101 599.175,396.931 570.513,396.93  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "574.193,373.501 602.956,373.502 602.822,374.332 574.063,374.331  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "573.411,378.481 602.152,378.483 602.019,379.312 573.281,379.311  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "572.629,383.46 601.349,383.461 601.215,384.292 572.498,384.29  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "571.846,388.44 600.544,388.441 600.411,389.271 571.716,389.27  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "571.065,393.419 599.742,393.42 599.608,394.251 570.934,394.249  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "570.282,398.399 598.938,398.4 598.804,399.23 570.152,399.229  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "622.586,375.874 622.422,376.851 609.314,376.85 609.477,375.873  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "625.983,375.874 630.585,375.875 630.42,376.851 625.818,376.851  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "624.988,381.739 629.588,381.739 629.421,382.717 624.822,382.716  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "621.596,381.739 621.429,382.716 608.333,382.715 608.497,381.738  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "623.994,387.602 628.588,387.602 628.422,388.58 623.829,388.58  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "620.603,387.602 620.438,388.579 607.354,388.579 607.517,387.601  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "535.664,352.02 533.933,363.133 717.387,363.142 719.418,352.029  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B6F1FF"
    },
    points: "633.844,397.445 628.945,425.999 671.333,426.001 676.411,397.447  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "665.782,426.001 671.333,426.001 674.265,409.512 668.7,409.512  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "660.232,426 666.792,426.001 669.001,413.534 662.428,413.533  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "656.195,426 661.242,426.001 665.354,402.674 660.291,402.674  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "649.634,426 658.213,426 661.113,409.512 652.513,409.511  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "644.588,426 651.652,426 653.341,416.348 646.266,416.348  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "638.029,425.999 645.093,426 648.521,406.293 641.436,406.293  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "630.964,425.999 641.562,425.999 643.373,415.543 632.76,415.542  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#8C8585"
    },
    points: "628.945,425.999 634.496,425.999 636.715,413.129 631.153,413.129  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#B6F1FF"
    },
    points: "573.985,431.019 569.645,458.041 609.766,458.043 614.267,431.022  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BAD55"
    },
    d: "M572.754,438.688l-3.109,19.353l40.121,0.002l1.018-6.116 c-3.13-2.68-6.082-4.758-8.107-4.56c-2.411,0.235-5.888,4.925-7.753,4.624c-1.157-0.19-0.552-2.307-1.337-2.797 c-1.589-0.986-3.208,0.273-4.728-0.259c-1.382-0.484-3.599-3.787-5.086-4.891c-2.054-1.519-3.909-2.451-6.26-3.605 C575.464,439.438,574.276,438.433,572.754,438.688z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BAD55"
    },
    d: "M598.322,447.474c1.041,1.304,3.024,1.781,4.896,1.38c0.024-0.052,0.045-0.107,0.068-0.16 c0.007,0.053,0.009,0.107,0.015,0.16c1.74,0.401,3.881-0.076,5.352-1.38c-1.866,0.143-3.455-0.515-4.206-2.599 c1.367,0.517,3.151,0.29,4.492-0.816c-2.072,0.152-3.907-3.663-3.841-4.092v0c0.688,0.255,1.467,0.163,2.253-0.267 c-0.657-0.457-1.335-1.061-1.848-1.857c-0.118-0.178-0.228-0.369-0.326-0.567c-0.163,0.198-0.337,0.389-0.513,0.567 c-0.776,0.796-1.656,1.4-2.464,1.857c0.644,0.43,1.392,0.522,2.164,0.267c-0.075,0.428-3.173,4.243-5.194,4.091 c0.973,1.105,2.683,1.332,4.22,0.816C601.948,446.958,600.143,447.617,598.322,447.474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BAD55"
    },
    d: "M585.041,451.532c1.042,1.305,3.023,1.782,4.893,1.381c0.025-0.053,0.046-0.106,0.069-0.16 c0.005,0.054,0.008,0.107,0.016,0.16c1.739,0.402,3.877-0.075,5.346-1.38c-1.865,0.143-3.456-0.515-4.209-2.599 c1.367,0.517,3.149,0.29,4.487-0.816c-2.07,0.152-3.912-3.663-3.846-4.092l0.001,0c0.686,0.255,1.465,0.164,2.249-0.266 c-0.656-0.457-1.333-1.062-1.85-1.858c-0.118-0.179-0.229-0.369-0.327-0.567c-0.162,0.198-0.335,0.388-0.512,0.567 c-0.775,0.796-1.653,1.4-2.459,1.858c0.644,0.43,1.393,0.522,2.164,0.266c-0.075,0.429-3.164,4.244-5.184,4.092 c0.975,1.105,2.683,1.332,4.22,0.816C588.663,451.017,586.859,451.676,585.041,451.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7BAD55"
    },
    d: "M577.578,443.54c1.046,1.304,3.03,1.782,4.903,1.381c0.023-0.053,0.045-0.107,0.068-0.16 c0.005,0.053,0.009,0.107,0.016,0.16c1.741,0.402,3.881-0.075,5.35-1.38c-1.869,0.143-3.459-0.516-4.219-2.599 c1.37,0.516,3.155,0.29,4.493-0.816c-2.073,0.153-3.921-3.663-3.857-4.092l0,0c0.689,0.255,1.467,0.164,2.253-0.266 c-0.659-0.457-1.34-1.062-1.855-1.858c-0.12-0.179-0.229-0.369-0.329-0.567c-0.163,0.198-0.335,0.388-0.512,0.567 c-0.775,0.796-1.652,1.4-2.458,1.857c0.646,0.43,1.396,0.521,2.167,0.266c-0.075,0.429-3.162,4.244-5.185,4.091 c0.977,1.106,2.688,1.333,4.225,0.817C581.205,443.025,579.399,443.683,577.578,443.54z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "557.852,360.597 565.54,360.598 566.508,354.56 558.813,354.56  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "547.602,360.597 555.29,360.597 556.248,354.56 548.554,354.56  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "537.865,360.596 545.553,360.596 546.502,354.559 538.808,354.559  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "708.185,360.077 714.822,360.078 715.591,355.861 708.948,355.861  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "673.103,462.794 697.332,462.795 714.676,367.743 690.103,367.742  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "692.397,372.341 710.718,372.342 710.996,370.808 692.672,370.807  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "696.523,375.407 710.16,375.408 710.438,373.875 696.799,373.874  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "695.143,383.073 708.764,383.073 709.044,381.54 695.42,381.54  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "693.764,390.738 707.369,390.739 707.649,389.206 694.039,389.205  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "692.383,398.404 705.974,398.404 706.253,396.871 692.659,396.871  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "694.246,388.056 707.857,388.056 708.136,386.523 694.523,386.522  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "691.005,406.069 704.579,406.07 704.858,404.537 691.28,404.536  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AAADA1"
    },
    points: "678.555,446.313 697.834,446.314 704.323,410.669 684.944,410.668  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "689.58,451.201 689.279,452.861 677.642,452.86 677.94,451.201  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFFFFF"
    },
    points: "692.596,451.202 696.682,451.202 696.38,452.861 692.296,452.861  "
  })))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#414436"
    },
    d: "M472.672,472.367c0,1.693,1.374,3.066,3.066,3.066l214.636,0.011 c1.694,0,3.067-1.372,3.067-3.065l0,0c0-1.694-1.372-3.066-3.066-3.066l-214.636-0.011 C474.046,469.301,472.672,470.673,472.672,472.367L472.672,472.367z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#43443F"
    },
    d: "M463.472,479.647c-0.001,3.706,3.259,6.71,7.284,6.71l227.282,0.012 c1.075,0,2.093-0.211,3.013-0.603c2.518-1.048,4.271-3.388,4.271-6.105c0-1.854-0.816-3.532-2.131-4.745 c-1.317-1.212-3.139-1.965-5.152-1.965l-227.282-0.012C466.731,472.939,463.472,475.941,463.472,479.647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0D1016"
    },
    d: "M629.818,479.656c0,2.781,1.833,5.164,4.445,6.18c0.873,0.344,1.828,0.53,2.834,0.53 l60.941,0.003c1.075,0,2.093-0.211,3.013-0.603c4.794-0.566,8.515-4.681,8.515-9.674v-3.14l-72.468-0.003 C633.079,472.948,629.819,475.95,629.818,479.656z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFEE9"
    },
    d: "M871.659,454.499c-0.078,0.008-0.161,0.008-0.242,0.008l-84.386-0.005 c-3.748,0-6.789-4.223-6.788-9.429c0-2.608,0.762-4.961,1.989-6.667c1.229-1.706,2.922-2.763,4.8-2.763l84.386,0.005 c0.082,0,0.164,0,0.243,0.007c-1.742,0.124-3.298,1.157-4.449,2.756c-1.229,1.705-1.99,4.058-1.99,6.667 C865.22,450.119,868.07,454.244,871.659,454.499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M868.007,438.61c-0.116,0.125-0.232,0.277-0.342,0.427c-0.108,0.152-0.211,0.303-0.308,0.465 l-65.929-0.003v-0.893L868.007,438.61z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M866.119,442.623c-0.058,0.295-0.116,0.59-0.154,0.892l-64.218-0.003v-0.893L866.119,442.623z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M866.119,447.529l-64.05-0.003v-0.892l63.896,0.003 C866.002,446.941,866.055,447.243,866.119,447.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M867.992,451.543l-65.603-0.004v-0.892l64.961,0.003 C867.551,450.972,867.768,451.276,867.992,451.543z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26514A"
    },
    d: "M867.992,451.543c-0.225-0.268-0.442-0.571-0.642-0.892c-0.551-0.902-0.981-1.953-1.232-3.122 c-0.064-0.286-0.116-0.588-0.154-0.892c-0.065-0.509-0.102-1.027-0.102-1.56c0.001-0.527,0.033-1.054,0.103-1.562 c0.038-0.303,0.096-0.598,0.154-0.892c0.252-1.14,0.668-2.201,1.238-3.12c0.097-0.162,0.2-0.313,0.308-0.465 c0.111-0.15,0.226-0.302,0.342-0.427c1.033-1.24,2.323-1.962,3.685-2.061l0.019-1.783c-0.098-0.01-0.194-0.01-0.297-0.01 l-84.386-0.004c-1.983,0-3.843,1.071-5.25,3.023c-1.405,1.953-2.176,4.54-2.177,7.297c0,5.69,3.331,10.319,7.426,10.319 l84.386,0.004c0.103,0,0.199,0,0.297-0.008l-0.019-1.785C870.278,453.506,868.993,452.738,867.992,451.543z M787.027,453.608 c-3.387-0.001-6.143-3.827-6.143-8.536c0-2.275,0.645-4.426,1.805-6.039c1.155-1.615,2.705-2.496,4.339-2.496l80.805,0.004 c-0.385,0.356-0.745,0.776-1.079,1.239c-0.192,0.268-0.371,0.543-0.534,0.83c-0.164,0.286-0.326,0.58-0.469,0.893 c-0.448,0.962-0.769,2.014-0.968,3.12c-0.046,0.295-0.091,0.598-0.121,0.892c-0.059,0.518-0.085,1.035-0.085,1.562 c0,0.534,0.026,1.051,0.085,1.56c0.029,0.304,0.075,0.597,0.126,0.892c0.193,1.124,0.526,2.177,0.962,3.122 c0.143,0.312,0.296,0.606,0.464,0.892c0.454,0.793,1,1.498,1.61,2.069L787.027,453.608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26514A"
    },
    d: "M806.995,455.321c-0.07,0.009-0.146,0.009-0.219,0.009l-76.842-0.004 c-3.414,0-6.179-4.593-6.178-10.257c0-2.837,0.691-5.397,1.81-7.253c1.118-1.854,2.659-3.006,4.369-3.006l76.841,0.004 c0.073,0,0.149,0,0.219,0.009c-1.587,0.136-3.004,1.259-4.052,2.997c-1.118,1.856-1.812,4.416-1.812,7.253 C801.131,450.559,803.729,455.046,806.995,455.321z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFEE9"
    },
    d: "M895.549,485.03c-0.078,0.013-0.161,0.013-0.242,0.013l-84.386-0.005 c-3.75,0-6.789-6.337-6.789-14.153c0.001-3.913,0.763-7.446,1.99-10.005c1.229-2.562,2.923-4.149,4.8-4.149l84.386,0.004 c0.082,0,0.165,0,0.243,0.012c-1.742,0.185-3.299,1.735-4.449,4.136c-1.23,2.559-1.99,6.091-1.99,10.004 C889.111,478.458,891.96,484.65,895.549,485.03z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M891.897,461.184c-0.115,0.189-0.231,0.416-0.341,0.641c-0.108,0.23-0.212,0.455-0.307,0.697 l-65.929-0.003v-1.339L891.897,461.184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M890.009,467.208c-0.057,0.442-0.116,0.884-0.154,1.339l-64.217-0.004v-1.339L890.009,467.208 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M890.009,474.572l-64.05-0.004v-1.339l63.896,0.004 C889.893,473.687,889.944,474.143,890.009,474.572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B7B59E"
    },
    d: "M891.883,480.596l-65.603-0.004v-1.339l64.961,0.005 C891.441,479.739,891.659,480.195,891.883,480.596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF402C"
    },
    d: "M891.883,480.596c-0.224-0.401-0.442-0.857-0.642-1.339c-0.552-1.352-0.981-2.932-1.232-4.686 c-0.065-0.429-0.116-0.884-0.154-1.339c-0.063-0.763-0.102-1.539-0.102-2.343c0-0.79,0.033-1.579,0.102-2.343 c0.038-0.455,0.096-0.897,0.154-1.339c0.251-1.714,0.668-3.306,1.239-4.685c0.095-0.243,0.199-0.468,0.307-0.697 c0.11-0.226,0.226-0.453,0.341-0.641c1.034-1.862,2.324-2.945,3.686-3.093l0.02-2.678c-0.098-0.013-0.195-0.013-0.295-0.013 l-84.388-0.005c-1.983,0-3.843,1.607-5.25,4.538c-1.405,2.932-2.175,6.813-2.175,10.951c-0.001,8.542,3.33,15.49,7.424,15.49 l84.388,0.004c0.1,0,0.197,0,0.295-0.013l-0.02-2.678C894.168,483.541,892.885,482.389,891.883,480.596z M810.917,483.697 c-3.387,0-6.143-5.744-6.142-12.812c0-3.414,0.644-6.641,1.804-9.064c1.156-2.423,2.705-3.747,4.34-3.747l80.805,0.004 c-0.385,0.536-0.746,1.164-1.079,1.86c-0.191,0.401-0.371,0.819-0.532,1.245c-0.167,0.429-0.327,0.871-0.47,1.339 c-0.449,1.446-0.77,3.024-0.969,4.685c-0.045,0.442-0.091,0.897-0.121,1.339c-0.058,0.777-0.085,1.552-0.085,2.343 c0,0.804,0.026,1.581,0.084,2.343c0.03,0.455,0.076,0.897,0.127,1.339c0.193,1.686,0.526,3.267,0.963,4.686 c0.142,0.468,0.296,0.91,0.465,1.339c0.454,1.191,1,2.249,1.61,3.106L810.917,483.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF402C"
    },
    d: "M830.885,486.269c-0.07,0.013-0.145,0.013-0.219,0.013l-76.842-0.004 c-3.414,0-6.178-6.895-6.178-15.396c0-4.258,0.693-8.101,1.81-10.884c1.119-2.785,2.66-4.512,4.37-4.512l76.841,0.004 c0.073,0,0.148,0,0.219,0.013c-1.587,0.202-3.005,1.889-4.053,4.499c-1.117,2.783-1.811,6.626-1.811,10.884 C825.022,479.119,827.62,485.853,830.885,486.269z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B9A98"
    },
    points: "260.787,827.577 226.883,500.974 202.57,501.028 255.099,827.577  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B9A98"
    },
    points: "473.537,827.588 434.052,499.853 413.553,501.039 466.081,827.588  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B9A98"
    },
    points: "984.779,827.615 1037.341,501.073 1015.135,499.884 979.079,827.615  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#9B9A98"
    },
    points: "773.866,827.604 826.425,501.061 802.914,502.139 767.105,827.604  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 165.078,
    y: 490.024,
    style: {
      fill: "#9B9A98"
    },
    width: 913.996,
    height: 19.926
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.078,
    y: 490.009,
    style: {
      fill: "#BCBBBB"
    },
    width: 327.805,
    height: 19.926
  })), /*#__PURE__*/React.createElement("rect", {
    x: 138.735,
    y: 485.419,
    style: {
      fill: "#D3D3D3"
    },
    width: 966.686,
    height: 9.2
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M534.487,467.951c-25.621-3.228-79.63-1.248-91.422-1.122l-22.596,10.187 c5.155,2.076,10.058,23.5,14.913,29.844c9.055,11.833,102.308-21.326,110.499-24.611 C544.413,477.5,535.808,472.73,534.487,467.951z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M577.795,463.696c-2.799-1.947-5.734-0.337-8.591-0.947c-3.091-0.66-3.925-1.881-7.478-1.837 c-3.87,0.048-4.637-0.757-8.142-1.449c-8.847-1.745-21.523,13.806-30.323,9.91l12.677,9.298 c8.452,2.69,17.191,8.277,25.794,1.515c7.143-5.614,9.913-11.376,20.24-10.287 C580.724,468.105,579.545,464.913,577.795,463.696z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M579.844,829.122c-4.707-8.992-7.991-10.42-15.028-15.882l-8.648-0.036 c-1.759,2.178-2.752,7.179-5.572,15.918H579.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4F2C45"
    },
    d: "M631.225,567.12c-52.775-24.322-179.158-25.811-179.158-25.811 c-57.389,10.088-33.651,52.838-28.478,77.217c17.809,0.837,118.09,1.464,135.494,3.499 c-0.753,14.727-3.899,160.947-2.915,191.179c2.237,0.685,6.405,0.646,8.648,0.036c17.64-39.444,50.921-140.381,57.299-167.17 C625.911,630.129,644.459,573.219,631.225,567.12z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M461.677,289.137l-39.596-18.852c1.69,23.422-12.011,38.186-15.332,47.862 c17.117,8.88,36.58,15.028,52.858,25.526C454.229,325.951,459.133,307.14,461.677,289.137z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M515.799,224.601c-1.89,10.3,1.91,21.57-7.565,36.606 c-8.039,12.751-14.371,46.687-22.614,52.965c-10.8,8.224-27.909-8.803-31.578-12.464c-4.401-4.375-22.483-3.554-23.435-9.775 c-0.797-5.185,14.477-33.177,12.336-35.261l74.297-46.652c-0.279,2.135,2.465,8.466,3.005,12.134 C521.002,227.278,516.746,219.48,515.799,224.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M510.511,252.118l-21.187,37.316c4.195,2.243,14.772,3.388,19.555,2.639 C510.255,280.376,510.929,256.673,510.511,252.118z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M504.445,266.698c0.917,0.094,2.094,0.46,3.317,0.944c-0.535,1.977-1.104,3.944-1.691,5.903 c-0.402,0.025-0.799,0.028-1.182,0.006c-1.762-0.114-3.082-0.669-4.237-2.086c-0.784-0.971-2.137-1.715-2.024-3.841 C500.539,267.22,502.479,266.909,504.445,266.698z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M502.049,260.079c0.81-0.727,1.725-1.307,2.642-1.627c0.786-0.297,1.58-0.396,2.303-0.26 c1.154,0.206,2.078,0.668,2.818,1.295c-0.559,2.558-1.283,5.324-2.002,7.982c-0.121,0.447-0.249,0.891-0.374,1.337 c-1.781-0.382-3.575-0.681-5.377-0.89c-0.028-0.004-0.052-0.007-0.078-0.014c-1.116-0.127-2.229-0.22-3.352-0.28 C498.186,265.397,499.712,262.14,502.049,260.079z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#30241B"
    },
    d: "M504.691,258.453c0.786-0.297,1.58-0.396,2.303-0.26c1.154,0.206,2.078,0.668,2.818,1.295 c-0.559,2.558-1.283,5.324-2.002,7.982c-0.121,0.447-0.249,0.891-0.374,1.337c-1.781-0.382-3.575-0.681-5.377-0.89 c-0.028-0.004-0.052-0.007-0.078-0.014c-0.317-2.317-0.156-5.179,0.068-7.826 C502.858,259.352,503.774,258.772,504.691,258.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M505.292,263.736c-0.379,1.317-0.991,2.267-1.338,2.147c-0.35-0.123-0.322-1.278,0.037-2.6 c0.358-1.317,0.926-2.3,1.296-2.177C505.658,261.236,505.671,262.421,505.292,263.736z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B2314"
    },
    d: "M545.364,218.071c-4.859,16.091-26.267,28.027-60.746,15.32 c-1.053,13.945-11.117,33.834-22.068,36.404c-2.597,0.613,0.694-8.839-2.765-9.147c-8.921-0.793-1.441,31.893-16.313,34.959 c-7.491,1.542-25.163-7.96-25.163-7.96c4.782-14.413-4.188-46.909-3.622-60.293c0.15-3.719,0.522-7.231,1.159-10.528 c1.033-5.343,2.766-10.132,5.452-14.341c-3.038-0.387-7.298,0.343-8.465-0.67c1.483-1.088,9.199-3.909,9.864-4.684 c0.687-0.791,0.605-4.554,0.979-5.729c0.622-1.938,1.672-4.213,2.932-5.748c0.749,2.147,1.034,4.797,2.523,6.72 c1.103-3.362,3.588-6.178,6.912-7.633c-0.796,1.441-1.25,3.481-1.231,5.471c0.777-0.426,1.57-0.84,2.398-1.231 c15.826-7.552,48.488,2.193,48.488,2.193s41.241-1.589,59.083,25.981C544.978,217.458,545.174,217.76,545.364,218.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#441D10"
    },
    d: "M500.448,292.176c-0.549,1.547-1.795,4.566-3.409,8.034c-0.527,1.137-1.094,2.323-1.697,3.521 c-3.417,6.832-7.789,14.024-11.005,14.71c-11.188,2.373-21.637-4.336-26.286-13.4c-2.707-5.271-2.235-45.913-1.146-50.883 l6.866,1.557c-0.521,8.761-1.887,22.391,7.317,27.2C479.488,287.307,491.774,289.316,500.448,292.176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#5B2A15"
    },
    d: "M493.13,255.559l0.2,6.333c0.717,1.006,15.602,0.883,18.876,1.062 c1.087-2.452,3.567-8.405,1.131-9.259C511.198,251.729,497.399,253.139,493.13,255.559z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M497.039,300.21c-0.527,1.137-1.094,2.323-1.697,3.521c-4.818-0.57-9.228-3.946-12.43-7.474 C486.957,298.253,492.515,301.28,497.039,300.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#30130B"
    },
    d: "M545.364,218.071c-4.859,16.091-26.267,28.027-60.746,15.32 c-1.053,13.945-11.117,33.834-22.068,36.404c-2.597,0.613,0.694-8.839-2.765-9.147c-8.921-0.793-1.441,31.893-16.313,34.959 c-7.491,1.542-25.163-7.96-25.163-7.96c4.782-14.413-4.188-46.909-3.622-60.293c0.15-3.719,0.522-7.231,1.159-10.528 c1.267,4.898,2.722,9.868,6.952,11.159c3.606,1.095,9.876-12.129,12.834-15.441c-1.335,9.024-8.883,20.708,3.097,26.694 c7.008,3.496,20.364-6.486,16.974-14.479c4.404,3.42,12.079,8.03,17.366,9.381c2.505-7.027,4.269-14.512,1.407-21.458 c12.019-1.037,21.034,6.22,32.438,8.962c6.524,1.571,13.822,4.268,20.577,3.087c4.238-0.744,15.295-2.878,17.29-7.575 C544.978,217.458,545.174,217.76,545.364,218.071z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M462.681,268.872c3.582-9.91-4.443-30.868-14.565-18.736 c-3.758,4.501-4.233,14.754-0.84,20.728c3.603,6.348,10.365,5.627,13.726,3.006L462.681,268.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E5804E"
    },
    d: "M452.278,251.723l0.086,0.392c1.5-0.729,4.258,1.369,4.884,3.577 c0.775,2.753-0.383,3.455-1.848,4.79c-1.556,1.421-7.232,7.72-0.75,7.179C463.738,266.903,459.498,245.18,452.278,251.723z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#172A49"
    },
    d: "M367.547,308.771c12.726-10.394,102.47,12.12,117.075,17.103 c35.234,12.023,21.343,63.504,19.007,91.407c-3.549,42.409-3.659,45.656-5.055,90.747c-0.87,28.098,2.92,53.645,5.033,72.816 c-20.37-4.877-42.971-8.874-64.495-12.774c-21.256-3.852-47.151-4.555-67.261-11.73c-14.547-5.19-9.386-14.752-9.706-29.99 c-0.413-19.706-2.538-39.518-2.902-59.341c-0.65-35.34-2.074-70.595-4.304-105.594 C353.991,346.498,354.564,319.373,367.547,308.771z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M470.307,811.623l-8.648-0.036c-1.841,2.28-2.837,7.642-5.974,17.159 c10.272,1.081,14.135-0.351,29.735-1.082C480.667,818.526,477.387,817.118,470.307,811.623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3A2134"
    },
    d: "M537.591,565.455c-52.775-24.322-166.048-43.798-166.048-43.798 c-57.389,10.089-47.636,70.874-42.464,95.252c17.81,0.837,118.091,1.465,135.495,3.499 c-0.752,14.727-3.899,160.947-2.916,191.18c2.238,0.685,6.405,0.646,8.648,0.036c17.64-39.443,55.12-156.152,61.608-182.914 C534.902,616.387,550.826,571.554,537.591,565.455z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#172A49"
    },
    d: "M406.977,292.868c-8.118,0.417-15.687,11.178-22.119,14.05l80.98,22.298 C459.321,301.896,414.65,292.473,406.977,292.868z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M620.85,467.672c-25.758-1.845-79.582,3.035-91.35,3.796l-22.015,11.387 c5.259,1.796,11.307,22.925,16.496,28.998c9.677,11.329,101.013-26.795,109.016-30.517 C631.274,476.674,622.425,472.373,620.85,467.672z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB278"
    },
    d: "M663.866,461.095c-2.9-1.793-5.744-0.028-8.63-0.484c-3.122-0.493-4.021-1.667-7.566-1.432 c-3.862,0.257-4.671-0.506-8.208-1.008c-8.928-1.267-20.75,14.944-29.747,11.526l13.159,8.604 c8.584,2.231,17.611,7.341,25.839,0.126c6.831-5.99,9.287-11.893,19.658-11.361 C667.028,465.34,665.679,462.216,663.866,461.095z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#172A49"
    },
    d: "M553.033,468.431c-3.887,6.384-8.267,15.19-13.019,23.206 c-5.086,8.564-10.606,16.216-16.435,19.002c-9.042-3.651-17.202-12.411-24.171-22.994 c-14.196-21.568-23.472-50.696-25.325-59.464c-1.26-5.983-5.131-18.402-2.277-23.518l7.599-22.789l3.697-11.091 l12.996-38.997c19.002,22.918,19.943,49.701,25.978,77.986C527.397,434.703,536.56,449.156,553.033,468.431z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#111F33"
    },
    d: "M540.014,491.638c-5.086,8.564-10.606,16.216-16.435,19.002 c-9.042-3.651-17.202-12.411-24.171-22.994c-8.495-16.026-12.184-36.181-16.048-53.209 c-3.812-16.815-4.814-34.458-4.001-51.789c0.015-0.258,0.022-0.516,0.045-0.774c0.372-6.377,1.716-13.134,3.788-18.963 l-0.759,7.591c0.448-0.281,0.426-1.791,0.774-0.85c-0.045,0.372-0.083,0.752-0.106,1.131 c-0.873,9.732,0.964,22.205,2.331,31.793c2.216,15.638,6.619,33.258,13.111,47.863 C503.841,462.374,522.212,487.668,540.014,491.638z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#3C4042"
    },
    points: "419.573,552.775 414.279,804.357 435.219,804.357 428.922,552.775  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4042"
    },
    d: "M320.778,829.122v-6.795c0,0,98.834-39.791,102.686-41.075v47.87H320.778z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3C4042"
    },
    d: "M424.748,829.122v-47.87c3.852,1.284,102.686,41.075,102.686,41.075v6.795H424.748z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828A8E"
    },
    d: "M423.464,829.122v-47.87c2.07,1.284,55.193,41.075,55.193,41.075v6.795H423.464z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AA2D4B"
    },
    d: "M286.772,646.774h294.479c6.943-4.344,11.611-12.313,11.611-21.423 c0-1.805,0.231-4.822,0.424-8.594c0.07-1.297,0.124-2.678,0.17-4.136c0.456-14.249-0.586-35.272-13.423-45.872 c-27.164-22.396-85.634-8.988-88.897-36.313c-15.892-133.118-29.424-167.063-40.579-187.121 c-7.476-13.44-20.367-25.621-35.658-34.145c-4.76-2.654-9.751-4.961-14.89-6.836c-31.831-11.61-69.053-6.805-89.861,31.723 C262.247,422.746,274.151,641.459,286.772,646.774z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D33361"
    },
    d: "M414.899,309.17c18.963,32.502,49.243,117.989,58.663,337.604h107.69 c6.943-4.344,11.611-12.313,11.611-21.423c0-1.805,0.231-4.822,0.424-8.594c0.07-1.297,0.124-2.678,0.17-4.136 c0.456-14.249-0.586-35.272-13.423-45.872c-27.164-22.396-85.634-8.988-88.897-36.313 c-15.892-133.118-29.424-167.063-40.579-187.121C443.08,329.876,430.19,317.694,414.899,309.17z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeMain);
export default __webpack_public_path__ + "static/media/home-main.8bf305bc20e84a30d3174a2334a67a8f.svg";
export { ForwardRef as ReactComponent };